import { CodetableWireFormat } from "app/infrastructure/ui/form/types-codetable";
import { ComplexValue } from "ui";

export const mapStatusCode = (code: CodetableWireFormat): ComplexValue<number> => ({
  value: code.v,
  description: code.d,
  backgroundColor: code.b  
});
